import { Popover } from 'antd';
import { useState, useEffect } from 'react';

const FloatingButton = ({ answerHistory, currentStage, quizData }) => {
    const [progress, setProgress] = useState('');
    const [selectedAnswers, setSelectedAnswers] = useState([]);

    useEffect(() => {
        const progressText = `${currentStage + 1} / ${quizData.length}`;
        setProgress(progressText);
        // Set selected answers from answerHistory, you can customize it further
        setSelectedAnswers(answerHistory.map(answer => ({ title: answer.title, option: answer.option })));
    }, [answerHistory, currentStage, quizData]);

    // Calculate the progress percentage
    const percentage = Math.round(((currentStage + 1) / quizData.length) * 100);

    const content = (
        <div className='border-[3px] rounded border-[#153970] p-[10px]'>
            <p className='brand-font text-[20px] font-semibold mb-[5px]'>Progress: {progress}</p>
            <p className='brand-font text-[20px] font-semibold mb-[2px]'>Selected Answers:</p>
            <ul>
                {selectedAnswers.map((answer, index) => (
                    <li key={index} className='mb-[5px]'>
                        <p className='brand-text text-[18px] font-semibold'>{answer.title}:</p>
                        <p className='brand-text text-[14px] font-semibold mb-[2px]'>{answer.option}</p>
                    </li>
                ))}
            </ul>
        </div>
    );

    return (
        <Popover content={content} trigger="click">
            <button
                className="fixed bottom-[65px] left-5 w-16 h-16  small-gradient border-dashed border-[#F37741] border-[3px] text-xl font-semibold rounded-full flex items-center justify-center z-50 bg-white"
            >
                {percentage}%
            </button>
        </Popover>
    );
};

export default FloatingButton;
